import React from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';
import ScreenOverlay from '../body/ScreenOverlay';

const Loading = ({ isTransparent }) => (
    <ScreenOverlay isTransparent={isTransparent}>
        <ReactLoading
            type="spin"
            color="#885388"
            height="125px"
            width="125px"
            data-testid="loading"
        />
    </ScreenOverlay>
);

Loading.propTypes = {
    isTransparent: PropTypes.bool,
};

Loading.defaultProps = {
    isTransparent: false,
};

export default Loading;
